// extracted by mini-css-extract-plugin
export default {"link":"Attachments_link__yoYMq"};